import { render } from "./BottomGradient.vue?vue&type=template&id=0af9d646&scoped=true"
const script = {}

import "./BottomGradient.vue?vue&type=style&index=0&id=0af9d646&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af9d646"]])

export default __exports__